import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CmSettingsService, PortalCoreFeature } from '@ats/cm/core';
import { CMOption } from '@ats/cm/ui';

export interface CmMultiselectData {
	options: CMOption[];
	title?: string;
	initialSelectedOptions: any[];
}

@Component({
    selector: 'cm-multiselect-modal',
    templateUrl: './cm-multiselect-modal.component.html',
    styleUrls: ['./cm-multiselect-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CmMultiselectModalComponent {
	form: UntypedFormGroup;
	portalCoreFeature: PortalCoreFeature;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public readonly data: CmMultiselectData,
		private readonly dialogRef: MatDialogRef<CmMultiselectModalComponent>,
		private readonly fb: UntypedFormBuilder,
		private readonly settings: CmSettingsService
	) {
		this.portalCoreFeature = this.settings.portalCoreFeature;
		this.form = this.fb.group({ selected: [this.data.initialSelectedOptions] });
	}

	handleSubmit(formValue: UntypedFormGroup): void {
		this.dialogRef.close(formValue);
	}
}
